var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('div',{staticClass:"lock-screen"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }